import Links from '@/shared/constants/navegacao';
import { getModuloRelatoriosAtividadesHabilitado } from '@/modules/system/configuracoes/modulo-relatorios-atividades-habilitado';
import { ReactElement, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

type Props = {
  children: ReactElement;
};

/**
 * Rotas do módulo só existem quando a configuração está habilitada.
 * Com o módulo desativado, responde como rota inexistente (404).
 */
export default function RelatoriosAtividadesFeatureGuard({ children }: Props) {
  const [habilitado, setHabilitado] = useState<boolean | null>(null);

  useEffect(() => {
    void getModuloRelatoriosAtividadesHabilitado().then(setHabilitado);
  }, []);

  if (habilitado === null) {
    return (
      <div className="p-4 text-center text-muted">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Carregando…</span>
        </div>
      </div>
    );
  }

  if (!habilitado) {
    return <Navigate to={Links.Nao_Existe} replace />;
  }

  return children;
}
